// generic phaser setups
export const GAME_WIDTH_DEFAULT = 1680;
export const GAME_HEIGHT_DEFAULT = 720;
export const GAME_BACKGROUND_COLOR = '0x00a2cc';
export const GAME_DIV_ID = 'game_container';
export const GAME_DIV_CLASSNAME = 'canvas_container absolute_center page_background trap';

// minigame id
export const FONT_TITLE = 'House-A-Rama-Kingpin';
export const FONT_COPY = 'FredFredburger-Condensed';
export const FONT_TITLE_OVERRIDE = 'FredFredburger-Bold';

// id for local storage saving
export const PLAYER_DATA_SAVEID = 'scoobydoo_worldtour_0.0.0';

// app state ids
export const STATE_BOOT = 'STATE_BOOT';
export const STATE_LOAD = 'STATE_LOAD';
export const STATE_WELCOME = 'STATE_WELCOME';
export const STATE_WORLD_MAP = 'STATE_WORLD_MAP';
export const STATE_SUITCASE = 'STATE_SUITCASE';
export const STATE_HOWTOPLAY = 'STATE_HOWTOPLAY';
export const STATE_LOCATION_LOADER = 'STATE_LOCATION_LOADER';
export const STATE_LOCATION = 'STATE_LOCATION';
export const STATE_ANIM_STORY_INTRO = 'STATE_ANIM_STORY_INTRO';
export const STATE_ANIM_STORY_END = 'STATE_ANIM_STORY_END';
export const STATE_ANIM_STORY_LOCATION = 'STATE_ANIM_STORY_LOCATION';
export const STATE_MINIGAME_LOADER = 'STATE_MINIGAME_LOADER';
export const STATE_MINIGAME_CHASE = 'STATE_MINIGAME_CHASE';
export const STATE_MINIGAME_FOOD = 'STATE_MINIGAME_FOOD';

// app locations
export const LOCATION_USA = 'USA';
export const LOCATION_MEXICO = 'MEXICO';
export const LOCATION_UK = 'UK';
export const LOCATION_FRANCE = 'FRANCE';
export const LOCATION_TURKEY = 'TURKEY';
export const LOCATION_SOUTHAFRICA = 'SOUTHAFRICA';
export const LOCATION_ROMANIA = 'ROMANIA';
export const LOCATION_UAE = 'UAE';
export const LOCATIONS = [
  LOCATION_USA,
  LOCATION_MEXICO,
  LOCATION_UK,
  LOCATION_FRANCE,
  LOCATION_TURKEY,
  LOCATION_SOUTHAFRICA,
  LOCATION_ROMANIA,
  LOCATION_UAE,
];
export const LOCATIONS_VISIT_ORDER = [
  LOCATION_USA,
  LOCATION_UK,
  LOCATION_ROMANIA,
  LOCATION_TURKEY,
  LOCATION_UAE,
  LOCATION_SOUTHAFRICA,
  LOCATION_FRANCE,
  LOCATION_MEXICO,
];

// minigame id
export const MINIGAME_FOOD = 'MINIGAME_FOOD';
export const MINIGAME_CHASE = 'MINIGAME_CHASE';

// app tutorial id
export const TUTORIAL_WORLDMAP = 'TUTORIAL_WORLDMAP';
export const TUTORIAL_LOCATION = 'TUTORIAL_LOCATION';
export const TUTORIAL_FOODGAME = 'TUTORIAL_FOODGAME';
export const TUTORIAL_CHASEGAME = 'TUTORIAL_CHASEGAME';



// WEBPACK FOOTER //
// ./js/app/constants/AppConstants.js